import React from 'react';
import DummyPage from '../components/DummyPage';
import PageContainer from '../containers/PageContainer';

const FAQPage = () => {
  return (
    <PageContainer>
      <DummyPage title="FAQ" />
    </PageContainer>
  );
};

export default FAQPage;
